import React, { useEffect, useState } from "react"
import { Button } from "react-bootstrap"

import PageLoadingPanel from "../../../shared_components/widgets/PageLoadingPanel"
import PageErrorPanel from "../../../shared_components/widgets/PageErrorPanel"
import { LanzaTable } from "../../../shared_components/widgets/LanzaTable"
import { API_STATUS } from "../../../shared_components/widgets/utils"
import { logToServer } from "../../../ErrorBoundary"
import { getObjectsList } from "../../../Loaders"
import { PageTitle } from "../../../config/AppSettingsConfigProvider"
import { LocaleFormattedDate } from "../../internationalization/LocaleFormatted"

export default function UserFiles({ intl }) {
  const [userFiles, setUserFiles] = useState([])
  const [statusUserFiles, setStatusUserFiles] = useState(API_STATUS.LOADING)

  const getUserFiles = () => {
    setStatusUserFiles(API_STATUS.LOADING)

    getObjectsList("/users/user-files/")
      .then((userFiles) => {
        setStatusUserFiles(API_STATUS.SUCCESS)
        setUserFiles(userFiles)
      })
      .catch((error) => {
        logToServer(error)
        console.error(error)
        setUserFiles([])
        setStatusUserFiles(API_STATUS.ERROR)
      })
  }

  useEffect(() => {
    getUserFiles()
  }, [])

  return (
    <div className="content-block full-height-min">
      <PageTitle
        glyph={"user"}
        id={"navigation.userFilesOption"}
        defaultMessage={"User Files"}
        description={"User Files"}
      />
      <hr />
      {statusUserFiles === API_STATUS.LOADING && <PageLoadingPanel />}

      {statusUserFiles === API_STATUS.ERROR && <PageErrorPanel attemptReload={getUserFiles} />}

      {statusUserFiles === API_STATUS.SUCCESS && (
        <div>
          <Button variant={"outline-primary"} style={{ float: "right" }} onClick={getUserFiles}>
            <span className={"fa fa-refresh"} />
            &nbsp;
            {intl.formatMessage({ id: "general.refresh", defaultMessage: "Refresh" })}
          </Button>
          <LanzaTable
            className={"table table-bordered table-hover tbl_lanzatable"}
            columns={[
              {
                Header: (
                  <span>{intl.formatMessage({ id: "general.filename", defaultMessage: "File Name" })}</span>
                ),
                accessor: "filename",
              },
              {
                Header: <span>{intl.formatMessage({ id: "general.type", defaultMessage: "Type" })}</span>,
                accessor: "filetype",
              },
              {
                Header: (
                  <span>
                    {intl.formatMessage({ id: "general.created.on", defaultMessage: "Created On" })}
                  </span>
                ),
                accessor: "date_created",
                Cell: ({ value }) => {
                  return <LocaleFormattedDate date={value} />
                },
              },
              {
                Header: (
                  <span>
                    {intl.formatMessage({ id: "general.updated.on", defaultMessage: "Updated On" })}
                  </span>
                ),
                accessor: "date_updated",
                Cell: ({ value }) => {
                  return <LocaleFormattedDate date={value} />
                },
              },
              {
                Header: <span>{intl.formatMessage({ id: "general.size", defaultMessage: "Size" })}</span>,
                disableFilters: true,
                disableSortBy: true,
                accessor: "size",
              },
              {
                Header: <span>{intl.formatMessage({ id: "general.status", defaultMessage: "Status" })}</span>,
                accessor: "status",
                className: "text-center",
              },
              {
                Header: (
                  <span>{intl.formatMessage({ id: "general.download", defaultMessage: "Download" })}</span>
                ),
                accessor: "file_url",
                disableFilters: true,
                disableSortBy: true,
                className: "text-center",
                Cell: ({ value, row }) => {
                  return (
                    <>
                      {row?.values?.size ? (
                        <a href={value}>
                          <span className={"fa fa-download"} /> &nbsp;
                          <span>
                            {intl.formatMessage({ id: "general.download", defaultMessage: "Download" })}
                          </span>
                        </a>
                      ) : (
                        <></>
                      )}
                    </>
                  )
                },
              },
            ]}
            data={userFiles}
            allowSorting={true}
            allowFilters={true}
            allowGlobalFilter={false}
            allowRowSelection={false}
            initialTableOptions={{
              sortBy: [{ id: "date_updated", desc: true }],
              pageSize: 10,
            }}
          />
        </div>
      )}
    </div>
  )
}
